import type { RouterConfig } from '@nuxt/schema'
import type { RouteRecordRaw } from 'vue-router'
import MemberShipRoutes from '~/router/modules/memberShip'
import HomeRoutes from '~/router/modules/home'

import knowledgeRoutes from '~/router/modules/knowledge'
import inquiryRoutes from '~/router/modules/inquiry'
import surveyRoutes from '~/router/modules/survey'

const webVitalsRoute: RouteRecordRaw = {
  path: '/:lang/web-vitals-report',
  meta: {
    title: 'WebVitals',
    pageCode: 'ERA.UC.WebVitals',
    layout: 'empty',
    ssr: false,
  },
  component: () => import('~/pages/web-vitals-report/index.vue'),
}

const wholeRoutes: any[] = [
  webVitalsRoute,
  ...MemberShipRoutes,
  ...knowledgeRoutes,
  ...inquiryRoutes,
  ...surveyRoutes,
  ...HomeRoutes,
]

const resetWindowScroll = () => {
  if (typeof window === 'undefined') return
  window.scrollTo(0, 0)
  document.documentElement.scrollTop = 0
  document.body.scrollTop = 0
}

export default {
  routes: (_nuxtRoutes) => {
    return [...wholeRoutes]
  },

  // 全局：前进跳转回顶；后退保留位置；hash 锚点保留
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }

    if (to.hash) {
      return {
        el: to.hash,
        top: 50,
        behavior: 'auto',
      }
    }

    resetWindowScroll()
    return new Promise((resolve) => {
      requestAnimationFrame(() => {
        resetWindowScroll()
        resolve({ top: 0, left: 0 })
      })
    })
  },
} satisfies RouterConfig
